module.exports = __webpack_public_path__ + "static/12-2b21deefe0b7dd601271c7e2b11e41a4.jpg";